import { Group, Text, Tooltip, Stack, ActionIcon } from "@mantine/core";
import { ProductAreaHeaderIcon, StatusHeaderIcon, OwnerHeaderIcon } from "../../../../../../icons/x-symbol-svgrepo-com";
import { truncateText } from "../../../../../../utils";
import { IconExternalLink } from "@tabler/icons";

interface AssignedIdeaComponentProps {
  assignedIdea: any;
}

const AssignedIdeaInfo = ({ assignedIdea }: AssignedIdeaComponentProps) => {
  return (
    <Stack    
      spacing={2} 
      p={'.75rem'}
      sx={{
        border: '1px solid #228be6',
        borderRadius: 4,
        backgroundColor: '#EFEFFD',
        width: '100%'
      }}
    >
      <Group position="apart" align="center">
        <Tooltip 
          label={assignedIdea?.title}
          position="top"
          withArrow
        >
          <Text fz={14} fw={600} color="#585C68">
            {truncateText(assignedIdea?.title, 40)}
          </Text>
        </Tooltip>
        <Tooltip withArrow label="Open idea in new tab">
          <ActionIcon
            onClick={() => window.open(`/idea/${assignedIdea?._id}`, "_blank")}
          >
            <IconExternalLink size={18} color="#5b60e3" />
          </ActionIcon>
        </Tooltip>
      </Group>
      <Group spacing={16}>
        { assignedIdea?.componentObj?.name && 
        <Group spacing={4}>
          <ProductAreaHeaderIcon size={14} color="#585C68" />
          <Text fz={12} color="#585C68">
            {assignedIdea?.componentObj?.name}
          </Text>
        </Group>
        }
        { assignedIdea?.ownerName &&
        <Group spacing={4}>
          <OwnerHeaderIcon size={14} color="#585C68" />
          <Text fz={12} color="#585C68">
            {assignedIdea?.ownerName}
          </Text>
        </Group>
        }
        { assignedIdea?.status &&
        <Group spacing={4}>
          <StatusHeaderIcon size={14} color="#585C68" />
          <Text fz={12} color="#585C68">
            {assignedIdea?.status}
          </Text>
        </Group>
        }
      </Group>    
    </Stack>
  );
};

export default AssignedIdeaInfo;